import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Country } from '@models/pais/paisDto.model';

@Injectable({
  providedIn: 'root'
})
export class PaisesService {
  private countriesUrl = 'https://restcountries.com/v3.1/all';
  private countriesAmericasUrl = 'https://restcountries.com/v3.1/region/americas';

  constructor(private http: HttpClient) { }



  // Método alternativo para obtener países con manejo de errores usando RxJS
  getCountriesObservable(): Observable<Country[]> {
    return this.http.get<Country[]>(this.countriesAmericasUrl).pipe(
      catchError(error => {
        console.error('Error fetching countries', error);
        return of([]); // Retorna un array vacío en caso de error
      })
    );
  }

  getSouthAmericanCountries(): Observable<{ name: string; flag: string }[]> {
    return this.http.get<any[]>(this.countriesAmericasUrl).pipe(
      map(countries =>
        countries
          .filter(country => country.subregion === 'South America')
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
  }

}
